@if (filteredKeyCoordinators$ | async; as filteredKeyCoordinators) {
  <ionic-selectable
    #selectableComponent
    [(ngModel)]="selectedItem"
    itemValueField="id"
    itemTextField="id"
    [items]="filteredKeyCoordinators"
    [canSearch]="true"
    (onSearch)="searchKeyCoordinators($event.text)"
    (onChange)="itemSelected($event)"
    [disabled]="disabled"
  >
    <ng-template ionicSelectableValueTemplate let-keyCoordinator="value">
      {{ keyCoordinator?.fullname }}
    </ng-template>
    <ng-template ionicSelectableCloseButtonTemplate>
      <ion-icon name="close" style="font-size: 24px"></ion-icon>
    </ng-template>
    <ng-template ionicSelectableItemTemplate let-keyCoordinator="item">
      {{ keyCoordinator.fullname }}
    </ng-template>
  </ionic-selectable>
}
